import * as Actions from './actions/actions'
import reducer from './reducers/index'
import SessionGenerator from './session-generator'
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import LiveChatState from '@alme/ui-web/modules/livechat-foundation/src/livechat-state'

export default class GenerateNewSession {
	_settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
	_init: any;
	_sessionGenerator!: SessionGenerator;
	_liveChatState : LiveChatState;

	constructor(settings: AlightCustomSettingsType, liveChatState: LiveChatState) {
		this._settings = settings;
		this._liveChatState = liveChatState;
	}

	setupSessionGenerator(initialize: any){
		this._init = initialize;
		this._sessionGenerator = new SessionGenerator(this._settings, this._init );
	}

	getPromise(){
        if (this.shouldAct()) {
            this._sessionGenerator._initializeCompleted = true
        }

        return Promise.resolve();
    }

	shouldAct()
    {
        return true;
    }

	getReducer() {
		return reducer;
	}

	initialize(store: Store<AlmeState>) {
		this._store = store;

		this._sessionGenerator.initialize(this._store);

		this.setupReset();
	}

	setupReset() {
		let funcName = this._settings.generateNewSession.GlobalFunctionName;
		let newSessionFlag = this._settings.stateLocations.GenerateNewSession.generateNewSessionFlag;
		let newSessionBase = this._settings.stateLocations.GenerateNewSession.Base;
		let resetEnabledLoc = this._settings.stateLocations.GenerateNewSession.resetEnabled;

		//@ts-ignore
		window[funcName] = async () => {
			//@ts-ignore
			let resetEnabled = this._store.getState()[newSessionBase][resetEnabledLoc];
			if (!resetEnabled) return false;
			try {
				console.log("NIT: Restart Started")
				var requireChatReset = this.resetLiveChatSession();
				let payload = {
					value: 'pending',
					stateLocation: `${newSessionBase}.${newSessionFlag}`
				};
				this._store?.dispatch(Actions.setGenerateNewSessionFlag(payload));

				if(requireChatReset === true){
					console.log("NIT: Resetting Live Chat")
					setTimeout(async () => {
						this._liveChatState.endChat("IVAReset", "Internal");
						this.resetSession();
						console.log("NIT: Live Chat Reset")
					}, this._settings.livechat.messagePollingInterval)
					
				}
				else{
					this.resetSession();
				}

				return true;
			} catch (e) {
				return false;
			}
		}
	}

	resetLiveChatSession(){
		if(this._liveChatState.isOnlineStatus(this._liveChatState.sessionStatus)){
			return true;
		}

		return false;
	}

	async resetSession() {
	    let stateLocation = `${this._settings.stateLocations.GenerateNewSession.Base}.${this._settings.stateLocations.GenerateNewSession.generateNewSessionFlag}`;

		let payload = {
			value: 'process',
			stateLocation
		};
		this._store?.dispatch(Actions.setGenerateNewSessionFlag(payload));

		return true;
	}
}



// WEBPACK FOOTER //
// ./modules/generate-new-session/nextit-generate-new-session.ts